export default "__VITE_ASSET__BSGMNdbP__"